import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddOperatorComponent } from '../add-operator/add-operator.component';
import { OpreatorsService } from 'src/app/services/opreators.service';
import { RolesService } from 'src/app/services/roles.service';
import { MainService } from 'src/app/services/main.service';
import { EditOpreatorsComponent } from '../edit-opreators/edit-opreators.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-opreators-main',
  templateUrl: './opreators-main.component.html',
  styleUrls: ['./opreators-main.component.css']
})
export class OpreatorsMainComponent implements OnInit {
  allOpreators: any;
  constructor(
    public dialog: MatDialog,
    private rest: OpreatorsService,
    private mainServ: MainService,
    private rolsService: RolesService
  ) {}

  ngOnInit() {
    this.get_opreators();
    this.getRoles();
  }

  get_opreators() {
    this.rest.retriveOpreators().subscribe((res: any) => {
      console.log(res);
      this.allOpreators = res;
    });
  }

  getRoles() {
    this.rolsService.retriveOpreators().subscribe((res: any) => {
      console.log(res);
    });

    this.rolsService.retrivePermison().subscribe((res: any) => {
      console.log('permison', res);
    });
  }

  addoperator() {
    const dialogRef = this.dialog.open(AddOperatorComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (result.data.web_login == 'true') {
          result.data.web_login = true;
        } else {
          result.data.web_login = false;
        }
        console.log(result);

        this.rest.addopreators(result.data).subscribe((res: any) => {
          console.log(res);
          for (let i = 0; i < result.rolesArr.length; i++) {
            for (let j = 0; j < result.rolesArr[i].roles.length; j++) {
              if (result.rolesArr[i].name == 'village') {
                let data = {
                  user_id: res.user.id,
                  village_id: result.rolesArr[i].villageId,
                  role_id: result.rolesArr[i].roles[j].id
                };
                this.rest.addroleForUser(data).subscribe((res: any) => {
                  console.log(res);
                  this.mainServ.SuccessToast('Operators added successfully');
                });
              } else {
                let data = {
                  user_id: res.user.id,
                  project_id: result.rolesArr[i].villageId,
                  role_id: result.rolesArr[i].roles[j].id
                };
                this.rest
                  .addroleForUserandProject(data)
                  .subscribe((res: any) => {
                    console.log(res);
                    this.mainServ.SuccessToast('Operators added successfully');
                  });
              }
            }
          }
          this.get_opreators();
        });
      }
    });
  }

  editOpreators(item: any) {
    const dialogRef = this.dialog.open(EditOpreatorsComponent, {
      width: '450px',
      data: item
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);

      if (result) {
        for (let i = 0; i < result.rolesArr.length; i++) {
          for (let j = 0; j < result.rolesArr[i].roles.length; j++) {
            if (result.rolesArr[i].name == 'village') {
              let data = {
                user_id: result.data.user_id,
                village_id: result.rolesArr[i].villageId,
                role_id: result.rolesArr[i].roles[j].id
              };
              this.rest.addroleForUser(data).subscribe((res: any) => {
                console.log(res);
                this.mainServ.SuccessToast('Operators Edit successfully');
              });
            } else {
              let data = {
                user_id: result.data.user_id,
                village_id: result.rolesArr[i].villageId,
                role_id: result.rolesArr[i].roles[j].id
              };
              this.rest
                .addroleForUserandProject(data)
                .subscribe((res: any) => {
                  console.log(res);
                  this.mainServ.SuccessToast('Operators Edit successfully');
                });
            }
          }
        }
        this.rest.editOpreators(result.data).subscribe((res: any) => {
          console.log(res);
          this.mainServ.SuccessToast('Operators edit successfully');
          this.get_opreators();
        });
      }
    });
  }

 


  DeleleOpreator(){}
}
